<template>
  <div>
    <div v-show="show">
      <headTop head-title='收件箱' go-user="true">
      </headTop>
      <scroll class="in-content" :data="list" :pullup="true" @pullup="scrollToEnd" :pulldown="true" @pulldown="pulldown" ref="scroll">
        <ul class="in-ul">
          <li @click="gotoDetail(item)" class="in-li" v-for="item in list" :key="item.id">
            <div class="middle-content">
              <div class="top-content">
                <span class="top-name">{{formatff(item.type)}}</span><span v-if="item.status==0" class="red-spot"></span><span class="top-time">{{item.created_at*1000 | formatDate}}</span>
              </div>
              <div class="message-tit">{{item.title}}</div>
            </div>
            <div class="right-icon">
              <i class="icon icon-right"></i>
            </div>
          </li>
        </ul>
        <div class="noData-bg" v-show="sta==1">
          <!-- <i class="icon zhuihaojilu"></i> -->
          <span>暂无数据</span>
        </div>
      </scroll>
    </div>
    <div v-show="!show">
      <detail-m :boxTit="'收件箱'" :detailObj="dObj" @getback="getback"></detail-m>
    </div>
  </div>
</template>

<script>
  import scroll from '@/components/common/scroll/scroll'
  import headTop from '@/components/common/header/head'
  import detailM from '@/components/message/detailM'
  import { messageResource, userResource } from '@/resource/resource'
  import { formatDate } from '@/common/js/common'
  import { deleteCookie } from '@/common/js/cookies'
  import { mapMutations } from 'vuex'
  const ERR_OK = 0
  export default {
    name: 'message',
    data () {
      return {
        sta: 0,
        list: [],
        listCondition: {
          count: 20,
          page: 0
        },
        total_page: 0,
        dObj: {},
        show: true
      }
    },
    created () {
      this.getList(this.listCondition)
    },
    mounted () {
    },
    methods: {
      getList (listCondition, isRefresh = false) {
        messageResource.list(listCondition).then(response => {
          response = response.body
          if (response.errcode === ERR_OK) {
            if (response.data) {
              if (isRefresh) {
                this.list = response.data
              } else {
                this.list = this.list.concat(response.data)
              }
              this.total_page = response.page.total_page
            }
          }
          this.$refs.scroll.finishPullDown()
          this.$refs.scroll.finishPullUp()
          this.sta = this.list.length ? 0 : 1
        })
      },
      //
      scrollToEnd () {
        this.listCondition.page++
        if (this.listCondition.page < this.total_page) {
          this.getList(this.listCondition)
        } else {
          this.$toast('没有更多数据')
        }
      },
      // 下拉刷新
      pulldown () {
        // this.stopTouchendPropagationAfterScroll()
        this.listCondition.page = 0
        this.getList(this.listCondition, true)
      },
      formatff(type) {
        let ret = ''
        switch (type) {
          case 1:
            ret = '系统公告'
            break
          case 2:
            ret = '系统消息'
            break
          case 3:
            ret = '站长消息'
            break
          default:
            break
        }
        return ret
      },
      gotoDetail (item) {
        this.dObj = item
        this.show = false
        if (item.status === 0) {
          this.readMes(item.id)
        }
      },
      readMes(id) {
        messageResource.read({id: id}).then(res => {
          res = res.body
          if (res.errcode === ERR_OK) {
            this.mesList.map(data => {
              if (data.id === id) {
                data.status = 1
                this.getUserInfo()
              }
            })
          }
        })
      },
      getUserInfo () {
        userResource.info().then(response => {
          response = response.body
          if (response.errcode === ERR_OK) {
            this.AUTO_USERINFO(response.data)
          } else {
            deleteCookie('isLogined')
          }
        })
      },
      ...mapMutations([
          'AUTO_USERINFO'
      ]),
      getback () {
        this.show = true
      }
    },
    filters: {
      formatDate(time) {
        let date = new Date(time)
        return formatDate(date, 'MM-dd hh:mm')
      }
    },
    components: {
      headTop,
      scroll,
      detailM
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../../common/stylus/mixin";
  .in-content
    position fixed
    top 0.9rem
    bottom 0
    left 0
    width 100%
    overflow hidden
    font-size $fz-t3
    color $c-b3
    .in-ul
      min-height 101%
      .in-li
        height 1.5rem
        background-color #fff
        border-bottom 1px solid #eeeeee
        display flex
        box-sizing border-box
        padding 0 0.28rem
        &:last-child
          border-bottom none
        .middle-content
          flex 1
          .top-content
            height 0.4rem
            line-height 0.4rem
            padding-top 0.25rem
            vertical-align middle
            padding-bottom 0.05rem
            position relative
            .red-spot
              display inline-block
              margin-left 0.16rem
              margin-bottom 0.1rem
              width 0.16rem
              height 0.16rem
              background-color #cd3c29
              border 0.01rem solid #cd3c29
              border-radius 50%
            .top-name
              display inline-block
              // vertical-align middle
              font-weight 700
              max-width 3.0rem
              font-size $fz-t5
              margin-right 0.2rem
              text-overflow ellipsis
              overflow hidden
              white-space nowrap
              color $c-b1
            .top-time
              position absolute
              top 0.25rem
              right 0
              display inline-block
              font-size $fz-t3
              color $c-b3
              overflow hidden
          .message-tit
            height 0.8rem
            width 6.0rem
            line-height 0.6rem
            text-overflow ellipsis
            overflow hidden
            white-space nowrap
        .right-icon
          width 0.45rem
          vertical-align middle
          line-height 1.5rem
          text-align right
          .icon
            width 0.15rem
            height 0.26rem
            display inline-block
            background-size cover
            &.icon-right
              bg-image('icon-right')
  .noData-bg
    display flex
    flex-direction column
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    & > span
      padding-top 0.1rem
      font-size $font-size-l
      text-align center
</style>



// WEBPACK FOOTER //
// src/components/message/message.vue